import React from 'react';
import styles from './Dropdown.module.css';

export const CustomDropdownMenuDivider = ({ className = '' }) => {
    return <div className={`${styles.divider} ${className}`} />;
};
